<template>
  <div class="listable">
    <template v-if="queue.length > 0">
      <div class="listable-head">
        <div class="th">Name</div>
        <div class="th">Email</div>
        <div class="th">Company</div>
        <div class="th">Brand</div>
      </div>

      <div v-for="(item, i) in queue" :key="i" class="listable-data">
        <input type="hidden" :name="`queue[${i}][user_id]`" :value="item.id" />
        <input
          type="hidden"
          :name="`queue[${i}][brand_id]`"
          :value="item.selectedBrand.id"
        />

        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-10">
                <h4 class="card-title">{{ item.name }}</h4>
                <div v-if="!!item.hvac_id" class="card-subtitle">
                  ID: {{ item.hvac_id }}
                </div>
              </div>
              <div class="col-2">
                <ContextMenu
                  :id="`queue_menu_${i}`"
                  :items="contextMenu(item)"
                  align="right"
                />
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card-text mt-0 row">
              <div class="col-12 col-sm-3 font-size-sm">EMAIL:</div>
              <div class="col-12 col-sm-9 font-size-sm mb-3 text-dark">
                {{ item.email }}
              </div>
              <div class="col-12 col-sm-3 font-size-sm">COMPANY:</div>
              <div class="col-12 col-sm-9 font-size-sm mb-3 text-dark">
                {{ item.company.name }}
              </div>
              <div class="col-12 col-sm-3 font-size-sm">BRAND:</div>
              <div class="col-12 col-sm-9 font-size-sm">
                <div v-if="item.enrollableBrands.length > 1" class="element">
                  <div class="select-wrapper">
                    <select
                      class="custom-select"
                      v-model="item.selectedBrand.id"
                    >
                      <option
                        v-for="option in item.enrollableBrands"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-else class="text-dark">
                  {{ item.selectedBrand.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="td">
          {{ item.name + (!!item.hvac_id ? ` (ID: ${item.hvac_id})` : "") }}
        </div>
        <div class="td">{{ item.email }}</div>
        <div class="td">
          {{
            item.company.name +
            (!!item.company.hvac_id ? ` (ID: ${item.company.hvac_id})` : "")
          }}
        </div>
        <div class="td">
          <div v-if="item.enrollableBrands.length > 1" class="element">
            <div class="select-wrapper">
              <select class="custom-select" v-model="item.selectedBrand.id">
                <option
                  v-for="option in item.enrollableBrands"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
          <div v-else>{{ item.selectedBrand.name }}</div>
        </div>
        <div class="td text-right">
          <a
            v-if="!!item.is_writein"
            href="#"
            @click.prevent="editWriteIn(item)"
            class="btn-sm btn-info font-size-sm mr-2"
            >Edit</a
          >
          <a
            href="#"
            @click.prevent="removeFromQueue(item)"
            class="btn-sm btn-danger font-size-sm"
            >Remove</a
          >
        </div>
      </div>
    </template>

    <template v-else>
      <div class="alert alert-info text-center">
        <span>You have not yet added anyone to the pending queue.</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    enrollableType: { type: String, required: true },
    enrollableId: { type: Number, required: true },
    queue: { type: Array, required: true },
  },
  methods: {
    contextMenu(user) {
      var menu = [];
      if (!!user.is_writein) {
        menu.push({
          label: "Edit Write-In",
          action: () => {
            this.editWriteIn(user);
          },
        });
      }
      menu.push({
        label: "Remove",
        action: () => {
          this.removeFromQueue(user);
        },
      });
      return menu;
    },
    editWriteIn(user) {
      this.$emit("edit-write-in", user);
    },
    removeFromQueue(user) {
      this.$emit("remove-from-queue", user);
    },
    selectedBrandLabel(user) {
      var brand = user.enrollableBrands.find(
        (b) => b.value == user.selectedBrandId
      );
      return brand ? brand.label : "";
    },
  },
};
</script>